import { withInstall } from "@xplus/utils/with-install";
import Switch from "./src/switch.vue";
export const xSwitch = withInstall(Switch);
export default xSwitch;
export * from "./src/switch";
